import { render, staticRenderFns } from "./MenuOption.vue?vue&type=template&id=09051054"
import script from "./MenuOption.vue?vue&type=script&lang=js"
export * from "./MenuOption.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports